import { motion } from "framer-motion";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { PageHero, reveal } from "@/components/site/primitives";
import Seo from "@/components/site/Seo";
import LeadForm from "@/components/site/LeadForm";
import { CONTACT } from "@/lib/data";
import { useI18n } from "@/i18n";

export default function Contact() {
  const { t } = useI18n();
  const INFO = [
    { icon: Phone, label: t("ct.callUs"), value: CONTACT.phone, href: CONTACT.phoneHref },
    { icon: Mail, label: t("ct.emailUs"), value: CONTACT.email, href: `mailto:${CONTACT.email}` },
    { icon: MapPin, label: t("ct.visit"), value: CONTACT.address },
    { icon: MapPin, label: t("ct.serviceArea"), value: CONTACT.area },
    { icon: Clock, label: t("ct.hours"), value: t("ct.hoursValue") },
  ];
  const contactJsonLd = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    name: t("ct.seoTitle"),
    description: t("ct.seoDesc"),
    url: "https://eewaste.com/contact",
    mainEntity: { "@id": "https://eewaste.com/#business" },
  };
  return (
    <>
      <Seo
        title={t("ct.seoTitle")}
        description={t("ct.seoDesc")}
        path="/contact"
        jsonLd={contactJsonLd}
      />
      <PageHero
        crumb={t("ct.crumb")}
        eyebrow={t("ct.eyebrow")}
        title={t("ct.title")}
        highlight={t("ct.highlight")}
        subtitle={t("ct.subtitle")}
      />

      <section className="relative bg-[#FBFAF8] py-24">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 grid lg:grid-cols-[0.9fr_1.1fr] gap-12 items-start">
          <motion.div variants={reveal} initial="hidden" whileInView="visible" viewport={{ once: true }} className="space-y-4">
            {INFO.map((it) => {
              const Inner = (
                <div className="flex items-center gap-4 p-5 rounded-2xl bg-white border border-[#E7E5DF] shadow-soft hover:border-emerald-600/50 transition-colors">
                  <span className="grid place-items-center w-12 h-12 rounded-xl bg-[#0E3B3B] text-emerald-300 shrink-0"><it.icon size={22} /></span>
                  <span>
                    <span className="block font-mono-tech text-[11px] uppercase tracking-widest text-slate-500">{it.label}</span>
                    <span className="block font-display font-bold text-lg text-[#0B0F14]">{it.value}</span>
                  </span>
                </div>
              );
              return it.href
                ? <a key={it.label} href={it.href} className="block" data-testid={`contact-${it.label.toLowerCase().replace(/\s/g, "-")}`}>{Inner}</a>
                : <div key={it.label} data-testid={`contact-${it.label.toLowerCase().replace(/\s/g, "-")}`}>{Inner}</div>;
            })}
          </motion.div>
          <motion.div variants={reveal} initial="hidden" whileInView="visible" viewport={{ once: true }}>
            <LeadForm heading={t("lead.heading")} />
          </motion.div>
        </div>
      </section>
    </>
  );
}
